import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';
import { media } from 'components/responsive';
import Footer from '../../Home/components/Footer';
import CaseStudy from '../components/Health/CaseStudy';
import Header from '../components/Health/Header';
import Partner from '../components/Health/Partner';
import Testimonials from '../components/Health/Testimonials';
import Awards from '../components/Health/Awards';
import Partners from '../components/Health/Partners';
import heroImg from '../../../assets/Health/hero_image.png';
const messages = defineMessages({
    title: 'Fighting Inactivity',
    title2: 'One Step at a Time',
    subtitle2: 'Making incentivised activity a pillar of preventative healthcare',
});
const HealthPage = () => {
    return (_jsxs(_Fragment, { children: [_jsxs(Layout, { children: [_jsx(Helmet, { link: [
                            {
                                rel: 'stylesheet',
                                href: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Prompt&family=Inconsolata:wght@800&display=swap',
                            },
                        ] }), _jsxs(SafeSpace, { children: [_jsx(Header, {}), _jsxs(Title, { id: "vision", children: [_jsx(FormattedMessage, Object.assign({}, messages.title)), _jsx("br", {}), _jsx(FormattedMessage, Object.assign({}, messages.title2))] }), _jsx(Subtitle, { children: _jsx(FormattedMessage, Object.assign({}, messages.subtitle2)) })] }), _jsx(HeroImg, { src: heroImg, alt: "sweatcoin logo" }), _jsxs(SafeSpace, { children: [_jsx(Partners, {}), _jsx(Partner, {}), _jsx(CaseStudy, {}), _jsx(Testimonials, {}), _jsx(Awards, {})] })] }), _jsx(Footer, {})] }));
};
const Layout = styled.div `
  margin: 0 auto;

  ${media.desktop `
    max-width: 1500px;
    min-width: 1024px;
    overflow: hidden;
  `};
`;
const SafeSpace = styled.div `
  margin: 0 auto;

  ${media.desktop `
    padding: 0 60px;
  `};
`;
const Title = styled.h1 `
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  color: #5E2394;
  font-size: 40px;
  letter-spacing: -0.3px;
  line-height: 1.2;
  text-align: center;
  margin-top: 88px;

  ${media.desktop `
    font-size: 74px;
  `};
`;
const Subtitle = styled.h2 `
  font-family: 'Inter', sans-serif;
  color: #000000;
  font-weight: 400;
  font-size: 24px;
  line-height: 1.25;
  text-align: center;
  margin: 50px 0 80px;
  padding: 0 16px;

  ${media.desktop `
    max-width: 640px;
    font-size: 18px;
    margin: 10px auto 40px;
  `};
`;
const HeroImg = styled.img `
  display: block;
  max-width: 100%;
  object-fit: contain;
  margin: 0 auto 140px;
`;
export default HealthPage;
